import api from "./apiClient.js";

const endpoint = "notifications";

export const getAllNotifications = () => {
	return api.get(endpoint);
};
